import { Card, CardItem } from 'src/app/components/Elements/Card';
import { FaxNumber, PhoneNumber } from 'src/app/components/Elements/Location';
import { Typography } from 'src/app/components/Elements/Typography';

import { ShowYourDoctorColumn, ShowYourDoctorRow } from './styles';

export const ContactSection = ({ facility }) => {
  return (
    <Card>
      <CardItem>
        <Typography variant="overline" color="capsuleGreen60">
          Address
        </Typography>
        <Typography variant="h4">{facility?.address?.name}</Typography>
        <Typography variant="body">{facility?.address?.address}</Typography>
        <Typography variant="body">
          {facility?.address?.city}, {facility?.address?.state} {facility?.address?.zipCode}
        </Typography>
        <ShowYourDoctorRow>
          <ShowYourDoctorColumn>
            <Typography variant="overline" color="capsuleGreen60">
              Phone
            </Typography>
            <Typography variant="body">
              <PhoneNumber />
            </Typography>
          </ShowYourDoctorColumn>
          <ShowYourDoctorColumn>
            <Typography variant="overline" color="capsuleGreen60">
              Fax
            </Typography>
            <Typography variant="body">
              <FaxNumber />
            </Typography>
          </ShowYourDoctorColumn>
        </ShowYourDoctorRow>
      </CardItem>
    </Card>
  );
};
